/************
 Swipers
 ************/

// thumbnails mobile
let productV12ThumbnailImages = new Swiper("#productV12ThumbnailsSwiper", {
    slidesPerView: "auto",
    spaceBetween: 5,
    breakpoints: {
        800: {
            slidesPerView: 6,
        }
    },
    loop: true,
    navigation: {
        nextEl: '#productV12ThumbnailsNext',
        prevEl: '#productV12ThumbnailsPrev',
    },
});

// main swiper
let productV12Images = new Swiper("#productV12Swiper", {
    navigation: {
        nextEl: '#productV12Swiper .swiper-button-next',
        prevEl: '#productV12Swiper .swiper-button-prev',
    },
    loop: true,
    thumbs: {
        swiper: productV12ThumbnailImages
    }
});

// gallery desktop
document.querySelectorAll(".productV12GalleryItem").forEach(function (element) {
    element.addEventListener("click", function () {
        // determine index
        let index = getElIndex(this);

        // change active slide
        productV12Images.slideTo(index);
    });
});

/********************
 Video Popup
 *******************/

// open video
document.querySelector("#productV12FormGroupHeaderVideo")?.addEventListener("click", function (e) {
    e.preventDefault();
    const popup = document.querySelector(".videoPopup");
    popup.showModal();
    popup.querySelector("video").play();
});

/*****************
 Reviews
 ****************/

document.querySelector("#productV12Review")?.addEventListener("click", function () {
    window.scrollTo({
        top: document.querySelector("#looxReviews").offsetTop - 100,
        behavior: "smooth"
    });
})


/**************
 Function To Update Pricing
 ***************/

// update active variant
function updateproductV12() {
    // There are 3 senarios to determine the active variant
    // 1. Has only a default variant
    // 2. the color/background swatch
    // 3. the basic dropdown

    // check for an active color swatch
    if (product.variants.length === 1) {
        activeVariant = product.variants[0];
    } else if (document.querySelector(".productV12FormGroup.active")) {
        activeVariant = product.variants.filter((variant) => {
            return variant.id === parseInt(document.querySelector(".productV12FormGroupFlexColor:checked").value)
        })[0];
    } else {
        activeVariant = product.variants.filter((variant) => {
            return variant.id === parseInt(document.querySelector("#productV12FormVariants").value)
        })[0];
    }

    // find variant image
    if (activeVariant.featured_image) {
        const variantImage = document.querySelector(`.productV12SwiperSlide[id="${activeVariant.featured_image.id}"]`);
        if (variantImage) {
            productV12Images.slideTo(getElIndex(variantImage));
        }
    }

    // in the variant available?
    let isAvailable = activeVariant.available;

    // default quantity and discount
    let quantity = 1;
    let discount = 0;

    // update pricing (check for bundle discount)
    if (document.querySelector("#productV12Bundle")) {
        // parse discount from the selected bundle
        quantity = parseInt(document.querySelector(".productV12BundleOptionsItemInput:checked").value);
        discount = parseInt(document.querySelector(".productV12BundleOptionsItemInput:checked").getAttribute("data-discount"));

        // check if any of the selected items are out of stock
        document.querySelectorAll(`.productV12FormGroup.active .productV12FormGroupFlexColor:checked`).forEach(function (element) {
            if (element.dataset.available === "false") {
                isAvailable = false;
            }
        });
    }

    // compute price and compare at price
    let total = activeVariant.price * quantity - discount;
    let compareAtTotal = activeVariant.compare_at_price * quantity;

    // check for addon
    const hasAddon = document.querySelector("#productV12AddonCheckboxInput:checked")
    if (hasAddon) {
        total += parseInt(document.querySelector(".productV12AddonFormVariantsItem:checked").dataset.price);
        compareAtTotal += parseInt(document.querySelector(".productV12AddonFormVariantsItem:checked").dataset.compare);
    }

    // calculate savings
    let savings = compareAtTotal - total;
    let savingsPercent = Math.round((savings / compareAtTotal) * 100);

    // update display
    if (total < compareAtTotal) {
        const prefix = hasAddon ? "BUNDLE" : "";
        document.querySelector("#productV12PriceCompare").textContent = price(compareAtTotal, true);
        document.querySelector("#productV12PriceActual").textContent = `${prefix} ${price(total, true)}`;
        document.querySelector("#productV12PriceSavings").textContent = `SAVE ${savingsPercent}%`;
        document.querySelector("#productV12PriceSavings").classList.add('active');

    } else {
        document.querySelector("#productV12PriceCompare").textContent = "";
        document.querySelector("#productV12PriceActual").textContent = price(total, true);
        document.querySelector("#productV12PriceSavings").classList.remove('active');
    }


    // check if the variant is in stock
    if (isAvailable) {
        document.querySelector("#productV12ATC").classList.remove("oos");
        document.querySelector("#productV12ATC").textContent = `Add To Cart`;
    } else {
        document.querySelector("#productV12ATC").classList.add("oos");
        document.querySelector("#productV12ATC").textContent = "Sold Out — Notify Me When Available";
    }

    // update BOGO box prices
    let BOGOExists = document.querySelector('.productV12BOGO') || false;
    if (BOGOExists) {
        document.querySelector('.productV12BOGOPriceReal').textContent = price(activeVariant.price, true);
        document.querySelector('.productV12BOGOPriceCompare').textContent = "";
        if (activeVariant.compare_at_price > activeVariant.price) {
            document.querySelector('.productV12BOGOPriceCompare').textContent = price(activeVariant.compare_at_price, true);
        }
    }
}

/*******************
 Product Form (Default and Group)
 ********************/

// color swatch support on change
document.querySelectorAll(".productV12FormGroupFlexColor").forEach(function (element) {
    element.addEventListener("change", function () {
        // update label
        this.parentElement.parentElement.querySelector(".productV12FormGroupHeaderLabel").innerHTML = this.getAttribute("aria-label");

        // update price
        updateproductV12();
    });
});

// variant dropdown support on change
document.querySelector("#productV12FormVariants")?.addEventListener("change", updateproductV12);

/***********************
 Product Bundle (Vibit Roll)
 *********************/

/*
Bundle is only shown on the vibit roll page
Bundle allows the user to change how many form groups are shown
 */

if (document.querySelector("#productV12Bundle")) {
    // on input change
    document.querySelectorAll(`.productV12BundleOptionsItemInput`).forEach(function (element) {
        element.addEventListener("change", function () {
            // get index to know how many groups to show in the productV12 form
            let index = parseInt(this.value);

            // hide all productV12 form groups
            document.querySelectorAll(".productV12FormGroup").forEach(function (element) {
                element.classList.remove("active");
            });

            // show the correct number of productV12 form groups
            for (let i = 0; i < index; i++) {
                document.querySelectorAll(".productV12FormGroup")[i].classList.add("active");
            }

            // update price
            updateproductV12();
        });
    });
}

// if url has bundle, preselect it
if (urlParams.has("bundle")) {
    document.querySelector(`.productV12BundleOptionsItemInput[value="${urlParams.get("bundle")}"]`)?.parentElement.click();
}

/****************
 *  Quantity
 *************/

let quantity = 1;

// minus
document.querySelector("#productV12QuantityMinus")?.addEventListener("click", function () {
    // must not be less than 1
    if (quantity === 1) {
        return;
    }

    // decrement by 1
    quantity--;
    document.querySelector("#productV12QuantityValue").textContent = quantity;
});

// plus
document.querySelector("#productV12QuantityPlus")?.addEventListener("click", function () {
    // increment by 1
    quantity++;
    document.querySelector("#productV12QuantityValue").textContent = quantity;
});


/***************
 Product Addon
 ****************/

// select addon
if (document.querySelector("#productV12Addon")) {
    // input change
    document.querySelector("#productV12AddonCheckboxInput").addEventListener("change", function () {
        // update product form
        updateproductV12();

        // on check
        if (this.checked) {
            // update active class on parent
            document.querySelector("#productV12Addon").classList.add("active");

            // uncheck bogo button
            document.querySelector('.productV12BOGO')?.classList.remove('active');

            quantity = 1;

            // hide note
            document.querySelector('#productV12Note')?.classList.remove('active');

            // switch slides
            productV12Images.slideTo(productV12Images.slides.length - 1);
        } else {
            // remove active class on parent
            document.querySelector("#productV12Addon").classList.remove("active");

            // check bogo button
            document.querySelector('.productV12BOGO')?.classList.add('active');
            productV12Images.slideTo(0);

            quantity = 2;

            // show note
            document.querySelector('#productV12Note')?.classList.add('active');

        }
    });

    // variant selection change
    document.querySelectorAll(".productV12AddonFormVariantsItem").forEach(function (element) {
        element.addEventListener("change", updateproductV12);
    });

    // if url has addon, preselect it
    if (urlParams.has("addon")) {
        document.querySelector("#productV12AddonCheckbox").click();
    }

    /***************
     BOGO Button
     ****************/
    // toggle between bogo and addon
    document.querySelector('.productV12BOGO')?.addEventListener('click', function () {
        if (this.classList.contains('active')) {
            this.classList.remove('active');
            document.querySelector("#productV12AddonCheckbox").click();

            quantity = 1;

            // hide note
            document.querySelector('#productV12Note').classList.remove('active');
        } else {
            this.classList.add('active');
            document.querySelector("#productV12AddonCheckbox").click();
            productV12Images.slideTo(0)

            quantity = 2;
            // show note
            document.querySelector('#productV12Note').classList.add('active');
        }

    });
}

/**************
 ORDERS REMAINING
 ***************/

// Consistent random number generation using the hash as a seed
function generateSeededRandom(key, min, max) {
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
        hash = (hash << 5) - hash + key.charCodeAt(i);
        hash |= 0;
    }

    const x = Math.sin(hash) * 10000;
    const seed = x - Math.floor(x);

    return Math.floor(seed * (max - min + 1) + min);
}

let ordersRemaining = localStorage.getItem('ordersRemaining');

// check local storage for orders remaining and set
if (ordersRemaining && localStorage.getItem('productHandle') === product.handle) {
    if (document.querySelector('#productV12ShippingRemainingTxt')) {
        document.querySelector('#productV12ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
    }
} else {
    // generate random number and set local storage if not found
    ordersRemaining = generateSeededRandom(product.handle, 10, 100);
    localStorage.setItem('ordersRemaining', ordersRemaining);
    localStorage.setItem('productHandle', product.handle);

    if (document.querySelector('#productV12ShippingRemainingTxt')) {
        document.querySelector('#productV12ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
    }
}


/**************
 Product ATC
 ***************/

// add to cart button
document.querySelector("#productV12ATC").addEventListener("click", async function (e) {
    e.preventDefault();

    // check for out of stock
    if (this.classList.contains("oos")) {
        // check email
        let {value: email} = await Swal.fire({
            title: product.title,
            text: "Enter your email to be notified when this product is back in stock.",
            input: "email",
            inputPlaceholder: "Email Address",
            confirmButtonText: "Notify Me When Available",
        });

        // confirm email is returned
        if (!email) {
            return;
        }

        // add to waitlist
        let formData = new FormData();
        formData.append("a", await klaviyo.account());
        formData.append("email", email);
        formData.append("g", "");
        formData.append("variant", activeVariant.id);
        formData.append("product", product.id);
        formData.append("platform", "shopify");
        formData.append("subscribe_for_newsletter", false);
        fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
            method: "POST",
            body: formData
        })

        // show success message
        await Swal.fire({
            title: "Success!",
            text: "You will be notified when this product is back in stock.",
            confirmButtonText: "OK",
        });

        return;
    }

    // add loading animation
    this.classList.add("loading");

    // determine which time of productV12 we're adding to cart
    // 1. Bundle
    // 2. Single Product

    // create form data
    let formData = {
        items: []
    };

    // check for BOGO (default to 2 quantity)
    if (document.querySelector('.productV12BOGO')?.classList.contains('active')) {
        quantity = 2;
    }

    // check for bundle
    if (document.querySelector("#productV12Bundle") && !document.querySelector('.productV12BOGO')?.classList.contains('active')) {
        // add each item to the form data
        document.querySelectorAll(".productV12FormGroup.active .productV12FormGroupFlexColor:checked").forEach(function (element) {
            formData.items.push({
                quantity: 1,
                id: parseInt(element.value),
                // important note here, since somebody can select 3 of the same color, we need to add a unique source for each item
                properties: {
                    "__source": element.getAttribute("name")
                }
            });
        });
    }
    // normal product
    else {
        formData.items.push({
            quantity: quantity,
            id: activeVariant.id,
        });
    }

    // check if addon
    const hasAddon = !!document.querySelector("#productV12AddonCheckboxInput:checked");
    if (hasAddon) {
        formData.items.push({
            quantity: 1,
            id: parseInt(document.querySelector(".productV12AddonFormVariantsItem:checked").value),
        });
    }

    // check if vibit roll, add tutorial video
    if (product.handle === "the-vibit" || hasAddon) {
        formData.items.push({
            quantity: 1,
            id: tutorial.variants[0].id,
        });
    }

    // add productV12
    await addProduct(formData);

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart();
});


// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // click normal atc
        document.querySelector("#productV12ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart_addon"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // check the addon if not already checked
        if (!document.querySelector("#productV12AddonCheckboxInput").checked) {
            document.querySelector("#productV12AddonCheckbox").click();
        }


        // click normal atc
        document.querySelector("#productV12ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

/**************
 Shipping Time
 ***************/

// show shipping tomorrow
let date = new Date();
date.setDate(date.getDate() + 1);
date = date.toLocaleDateString('en-US', {month: 'short', day: 'numeric'});

if (document.querySelector('#productV12ShippingDateTxt')) {
    document.querySelector('#productV12ShippingDateTxt').innerHTML = `Ships <strong>Tomorrow, ${date}</strong>`;
}


/**************
 Sticky ATC
 ***************/

const stickyAtcObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
        if (entry.isIntersecting) {
            document.querySelector("#productV12ATC").classList.remove("sticky");
        } else {
            document.querySelector("#productV12ATC").classList.add("sticky");
        }
    });
}, {
    rootMargin: "-100px 0px 0px 0px"
})

stickyAtcObserver.observe(document.querySelector("#productV12Content"));

// event listeners for dropdown items
document.querySelectorAll(`.productV12DropdownTop`).forEach(function (element) {
    element.addEventListener("click", function () {
        this.parentElement.classList.toggle("active");
    });
});

